import { WELLNESS_STATE_LIMIT_DANGER, WELLNESS_STATE_LIMIT_OK } from '@/constants/numberVars.ts';
import colors from '@/theme/colors';

export const getColorFromPercentage = (percentage: number) => {
  if (percentage < WELLNESS_STATE_LIMIT_DANGER) return colors.extra.red;
  if (percentage < WELLNESS_STATE_LIMIT_OK) return colors.extra.yellow;
  return colors.extra.teal;
};
